export default __webpack_public_path__ + "static/media/Montserrat-Medium.b8c6753b.ttf";